import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const StatementExpensesSkeleton = () => {
  const cells = new Array(4).fill('');
  return (
    <>
      <div className='w-full mb-3'><Skeleton height={20} /></div>
      <div className='flex flex-wrap gap-8'>
        {cells.map(() => (
          <React.Fragment key={Math.random()}>
            <Skeleton width={166} height={130} />
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default StatementExpensesSkeleton;
